/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { superVoterAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type DelegateSuperVoterManagerProps = {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  managerAddress: Address
}

export const delegateSuperVoterManager = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  managerAddress,
}: DelegateSuperVoterManagerProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: superVoterAbi as Abi,
        account,
        address: superVoterAddress,
        args: [managerAddress],
        chainId,
        functionName: "setManager",
      },
    })
    return result
  } catch (error: any) {
    console.error("delegateSuperVoterManager", error)
    return { success: false, error: error.message, code: error.code }
  }
}
